import { httpClient } from './httpClient';

export interface MetadataItem {
  id: number;
  name: string;
  description?: string;
  is_active: boolean;
  created_at: string;
  updated_at: string;
}

export interface SelectOption {
  value: string;
  label: string;
}

const mapToSelectOptions = (items: MetadataItem[]): SelectOption[] => {
  return items
    .filter(item => item.is_active)
    .map(item => ({
      value: item.id.toString(),
      label: item.name
    }));
};

export const metadataService = {
  getCategories: async (): Promise<SelectOption[]> => {
    const response = await httpClient.get<MetadataItem[]>('/api/categories');
    return mapToSelectOptions(response);
  },

  getGroups: async (): Promise<SelectOption[]> => {
    const response = await httpClient.get<MetadataItem[]>('/api/groups');
    return mapToSelectOptions(response);
  },

  getTypes: async (): Promise<SelectOption[]> => {
    const response = await httpClient.get<MetadataItem[]>('/api/types');
    return mapToSelectOptions(response);
  },

  getTags: async (): Promise<SelectOption[]> => {
    const response = await httpClient.get<MetadataItem[]>('/api/tags');
    return mapToSelectOptions(response);
  },

  getSources: async (): Promise<SelectOption[]> => {
    const response = await httpClient.get<MetadataItem[]>('/api/sources');
    return mapToSelectOptions(response);
  }
};
